import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CachedFacebookPage {
  id: string;
  user_id: string;
  ad_account_id: string | null;
  page_id: string;
  page_name: string;
  display_name: string;
  linked_instagram_id: string | null;
  linked_instagram_username: string | null;
  last_synced_at: string | null;
  created_at: string | null;
}

export function useCachedFacebookPages(userId: string | undefined, options?: { refetchInterval?: number | false | ((query: any) => number | false) }) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["cached-facebook-pages", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("meta_cached_facebook_pages")
        .select("*")
        .eq("user_id", userId!)
        .order("page_name");

      if (error) throw error;
      return data as CachedFacebookPage[];
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    refetchInterval: options?.refetchInterval ?? ((query) => {
      const currentData = query.state.data;
      if (!currentData || currentData.length === 0) return 3000;
      return false;
    }),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ["cached-facebook-pages", userId] });
  };

  return { ...query, invalidate };
}
